/* ============================================================
   WISHLIST N'GO — favoris localStorage (compte-ready)
   CUSTOM — voir docs/superpowers/specs/2026-06-24-wishlist-design.md
   ============================================================ */
(function () {
  'use strict';

  var GUEST_KEY = 'ngo_wishlist';

  function customerId() {
    return (typeof window.NGO_CUSTOMER_ID !== 'undefined' && window.NGO_CUSTOMER_ID)
      ? String(window.NGO_CUSTOMER_ID) : null;
  }
  function storageKey() {
    var id = customerId();
    return id ? (GUEST_KEY + '_' + id) : GUEST_KEY;
  }

  // Fallback mémoire si localStorage indisponible (navigation privée / quota)
  var memory = null;

  function read(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return memory ? memory.slice() : [];
    }
  }
  function write(key, list) {
    memory = list.slice();
    try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  function currentList() { return read(storageKey()); }

  // Fusion liste invité -> liste compte (à la connexion), puis vide l'invité
  function mergeGuestIntoCustomer() {
    var id = customerId();
    if (!id) return;
    var guest;
    try { guest = read(GUEST_KEY); } catch (e) { guest = []; }
    if (!guest || !guest.length) return;
    var acct = read(storageKey());
    var seen = {};
    acct.forEach(function (it) { seen[it.handle] = true; });
    guest.forEach(function (it) { if (!seen[it.handle]) acct.push(it); });
    write(storageKey(), acct);
    try { window.localStorage.removeItem(GUEST_KEY); } catch (e) {}
  }

  function emit() {
    var list = currentList();
    document.dispatchEvent(new CustomEvent('ngo:wishlist:change', {
      detail: { count: list.length, list: list }
    }));
  }

  var Wishlist = {
    list: function () {
      return currentList().slice().sort(function (a, b) { return (b.addedAt || 0) - (a.addedAt || 0); });
    },
    has: function (handle) {
      return currentList().some(function (it) { return it.handle === handle; });
    },
    count: function () { return currentList().length; },
    add: function (handle, id) {
      if (!handle || this.has(handle)) return;
      var list = currentList();
      list.push({ handle: handle, id: id ? String(id) : '', addedAt: Date.now() });
      write(storageKey(), list);
      emit();
    },
    remove: function (handle) {
      var list = currentList().filter(function (it) { return it.handle !== handle; });
      write(storageKey(), list);
      emit();
    },
    toggle: function (handle, id) {
      if (this.has(handle)) this.remove(handle); else this.add(handle, id);
    },
    onChange: function (cb) {
      document.addEventListener('ngo:wishlist:change', cb);
      return function () { document.removeEventListener('ngo:wishlist:change', cb); };
    },
    // Point d'extension futur (app/proxy) : aujourd'hui no-op.
    sync: function () { /* TODO futur : pousser/tirer la liste vers un backend */ }
  };

  mergeGuestIntoCustomer();
  window.NgoWishlist = Wishlist;

  // ----- Boutons cœur : délégation + hydratation -----
  var I18N = {
    add: (window.NGO_WL_I18N && window.NGO_WL_I18N.add) || 'Ajouter aux favoris',
    remove: (window.NGO_WL_I18N && window.NGO_WL_I18N.remove) || 'Retirer des favoris'
  };

  function reflectButton(btn) {
    var active = Wishlist.has(btn.getAttribute('data-handle'));
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('is-active', active);
    var label = active ? I18N.remove : I18N.add;
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }
  function reflectAll() {
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    Array.prototype.forEach.call(btns, reflectButton);
  }

  // Clic (délégué) : ne déclenche pas le lien d'une carte
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    Wishlist.toggle(btn.getAttribute('data-handle'), btn.getAttribute('data-id'));
  });

  // ----- Compteur header -----
  function updateCount() {
    var n = Wishlist.count();
    var els = document.querySelectorAll('[data-wishlist-count]');
    Array.prototype.forEach.call(els, function (el) {
      el.textContent = n > 9 ? '9+' : String(n);
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  // ----- Page favoris (rendu client-side) -----
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'EUR' }).format((cents || 0) / 100);
    } catch (e) { return ((cents || 0) / 100).toFixed(2) + ' ' + (currency || ''); }
  }
  function imgUrl(url, w) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? ('https:' + url) : url;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 500);
  }
  function esc(s) { return String(s || '').replace(/"/g, '&quot;'); }
  function cardHTML(p, currency) {
    return '' +
      '<div class="wishlist-card">' +
        '<a class="wishlist-card__media" href="' + p.url + '">' +
          (p.featured_image ? '<img src="' + imgUrl(p.featured_image, 500) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="wishlist-card__info">' +
          '<a class="wishlist-card__title" href="' + p.url + '">' + (p.title || '') + '</a>' +
          '<span class="wishlist-card__price">' + money(p.price, currency) + '</span>' +
        '</div>' +
        '<button type="button" class="wishlist-btn wishlist-btn--card is-active" data-wishlist-toggle ' +
          'data-handle="' + p.handle + '" data-id="' + (p.id || '') + '" aria-pressed="true">' +
          '<svg class="wishlist-btn__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5 4.2 12.9a4.6 4.6 0 0 1 6.5-6.5l1.3 1.3 1.3-1.3a4.6 4.6 0 0 1 6.5 6.5L12 20.5z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</div>';
  }

  function renderWishlistPage() {
    var section = document.querySelector('[data-wishlist-section]');
    if (!section) return;
    var grid = section.querySelector('[data-wishlist-grid]');
    var empty = section.querySelector('[data-wishlist-empty]');
    var loading = section.querySelector('[data-wishlist-loading]');
    var currency = section.getAttribute('data-currency') || 'EUR';
    var items = Wishlist.list();

    function showEmpty() {
      if (loading) loading.setAttribute('hidden', '');
      grid.setAttribute('hidden', '');
      empty.removeAttribute('hidden');
    }

    if (!items.length) { showEmpty(); return; }

    Promise.all(items.map(function (it) {
      return fetch('/products/' + it.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      if (loading) loading.setAttribute('hidden', '');
      var html = '';
      var kept = 0;
      products.forEach(function (p, i) {
        if (!p) { Wishlist.remove(items[i].handle); return; } // produit supprimé -> retiré
        html += cardHTML(p, currency);
        kept++;
      });
      if (!kept) { showEmpty(); return; }
      grid.innerHTML = html;
      grid.removeAttribute('hidden');
      empty.setAttribute('hidden', '');
    });
  }

  // Sur la page favoris : retire en live la carte décochée (et bascule en état vide si plus rien)
  Wishlist.onChange(function () {
    var section = document.querySelector('[data-wishlist-section]');
    if (!section) return;
    var grid = section.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var cards = grid.querySelectorAll('.wishlist-card');
    Array.prototype.forEach.call(cards, function (card) {
      var btn = card.querySelector('[data-wishlist-toggle]');
      var handle = btn && btn.getAttribute('data-handle');
      if (handle && !Wishlist.has(handle)) {
        card.parentNode.removeChild(card);
      }
    });
    if (!grid.querySelector('.wishlist-card')) {
      grid.setAttribute('hidden', '');
      section.querySelector('[data-wishlist-empty]').removeAttribute('hidden');
    }
  });

  // Hydratation + abonnements
  Wishlist.onChange(reflectAll);
  Wishlist.onChange(updateCount);

  function init() {
    reflectAll();
    updateCount();
    renderWishlistPage();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
